import { CaretLeftIcon, CaretRightIcon } from '@phosphor-icons/react';
import { Button } from '@/ui/button/Button';

interface PaginationProps {
  page: number; // 1-indexed
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
}

export function Pagination({ page, pageSize, total, onPageChange }: PaginationProps) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const start = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  return (
    <div className="flex items-center justify-between text-2xs text-fg-muted px-1">
      <span>
        Showing <span className="text-fg-secondary font-medium">{start}</span>–
        <span className="text-fg-secondary font-medium">{end}</span> of{' '}
        <span className="text-fg-secondary font-medium">{total}</span>
      </span>
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          iconLeft={<CaretLeftIcon size={12} />}
        >
          Prev
        </Button>
        <span className="tabular-nums">
          Page {page} of {totalPages}
        </span>
        <Button
          variant="ghost"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          iconRight={<CaretRightIcon size={12} />}
        >
          Next
        </Button>
      </div>
    </div>
  );
}
